<template>
  <div>
    <b-card title="Sorting Report">
      <b-row>
        <b-col
          cols="12"
          lg="4"
          class="align-items-start"
        >
          <b-form-group label="Sorting Date">
            <b-form-datepicker
              v-model="sortingDate"
              class="w-100 sorting-date"
              @input="getSortingIdString"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          class="align-items-start"
        >
          <b-form-group label="Selected Bucket">
            <v-select
              v-model="bucket"
              :reduce="option => option.value"
              label="name"
              placeholder="Select Bucket"
              :options="availableBuckets"
              @input="getSortingIdString"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          class="mt-md-2"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="fetchStats()"
          >
            <feather-icon
              icon="CornerLeftDownIcon"
              class="mr-50"
            />
            <span class="align-middle">Get Data</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <div
      v-if="loading"
      class="d-flex justify-content-center align-items-center"
      style="height: 50vh;"
    >
      <b-spinner label="Loading..." />
    </div>
    <div v-else>
      <div v-if="!hideWidgets">
        <b-row>
          <b-col
            cols="12"
            md="4"
          >
            <stats-card
              :value="upcoming"
              label="UP COMING ORDERS"
              tile-icon="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGJiZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jbG9jay1hcnJvdy1kb3duLWljb24gbHVjaWRlLWNsb2NrLWFycm93LWRvd24iPjxwYXRoIGQ9Ik0xMi4zMzggMjEuOTk0QTEwIDEwIDAgMSAxIDIxLjkyNSAxMy4yMjciLz48cGF0aCBkPSJNMTIgNnY2bDIgMSIvPjxwYXRoIGQ9Im0xNCAxOCA0IDQgNC00Ii8+PHBhdGggZD0iTTE4IDE0djgiLz48L3N2Zz4="
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <stats-card
              :value="toSort"
              label="TO BE SORT"
              blob-color="#F38F3B"
              tile-icon="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmMzhmM2IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jbG9jay1mYWRpbmctaWNvbiBsdWNpZGUtY2xvY2stZmFkaW5nIj48cGF0aCBkPSJNMTIgMmExMCAxMCAwIDAgMSA3LjM4IDE2Ljc1Ii8+PHBhdGggZD0iTTEyIDZ2Nmw0IDIiLz48cGF0aCBkPSJNMi41IDguODc1YTEwIDEwIDAgMCAwLS41IDMiLz48cGF0aCBkPSJNMi44MyAxNmExMCAxMCAwIDAgMCAyLjQzIDMuNCIvPjxwYXRoIGQ9Ik00LjYzNiA1LjIzNWExMCAxMCAwIDAgMSAuODkxLS44NTciLz48cGF0aCBkPSJNOC42NDQgMjEuNDJhMTAgMTAgMCAwIDAgNy42MzEtLjM4Ii8+PC9zdmc+"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <stats-card
              :value="sorted"
              label="SORTED ORDERS"
              blob-color="#1FDA70"
              tile-icon="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMxZmRhNzAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jaXJjbGUtY2hlY2stYmlnLWljb24gbHVjaWRlLWNpcmNsZS1jaGVjay1iaWciPjxwYXRoIGQ9Ik0yMS44MDEgMTBBMTAgMTAgMCAxIDEgMTcgMy4zMzUiLz48cGF0aCBkPSJtOSAxMSAzIDNMMjIgNCIvPjwvc3ZnPg=="
            />
          </b-col>
        </b-row>

        <!-- Buckets -->
        <bucket-grid
          :buckets="buckets"
          :is-report="true"
          :sorting-string="sortingIdString"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BSpinner, BButton, BCard, BFormGroup, BFormDatepicker,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import StatsCard from '@/components/Sorting/StatsCard.vue'
import BucketGrid from '@/components/Sorting/BucketGrid.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import SuccessBell from '@core/mixins/SuccessBell'
import ErrorBell from '@core/mixins/ErrorBell'

const sortingRepository = RepositoryFactory.get('sorting')

export default {
  directives: {
    Ripple,
  },
  components: {
    StatsCard,
    BucketGrid,
    BRow,
    BCol,
    BSpinner,
    BButton,
    BCard,
    BFormGroup,
    BFormDatepicker,
  },
  mixins: [SuccessMessage, ErrorMessage, SuccessBell, ErrorBell],
  data: () => ({
    loading: false, // Add loading state
    loggedIn: false,
    upcoming: 0,
    toSort: 0,
    sorted: 0,
    availableBuckets: [],
    sortingDate: new Date().toISOString().split('T')[0],
    sortingId: '',
    category: 'Night Operations',
    bucket: null,
    currentLocation: '',
    fullPath: [],
    buckets: [],
    bucketName: '',
    scanStatus: '',
    scanMsg: '',
    scanCode: '',
    scanBucket: '',
    scanWaybill: '',
    isStarting: false,
    hideWidgets: true,
    bucketColor: 'rgb(115, 103, 240)', // default color
    sortingIdString: '',
  }),
  mounted() {
    this.fetchBuckets()
  },
  methods: {
    async fetchBuckets() {
      try {
        const response = await sortingRepository.getAvailableBucketsforReporting()
        this.availableBuckets = (response.data.data ?? []).map(bucket => ({
          value: bucket.id.toString(),
          text: `${bucket.name} (${bucket.key})`,
          key: bucket.key,
          name: bucket.name,
        }))
      } catch (error) {
        // console.error('Error fetching available buckets', error)
      }
    },
    async fetchStats() {
      if (!this.bucket) {
        this.showErrorMessage('Please select a bucket')
        return
      }
      this.loading = true
      try {
        if (!this.sortingIdString) return

        const reqRes = await sortingRepository.getReportOverall(this.sortingIdString)
        if (reqRes.status === 200) {
          const response = reqRes.data
          this.upcoming = response.data[0]?.upcoming_orders ?? 0
          this.toSort = response.data[0]?.to_be_sorted_orders ?? 0
          this.sorted = response.data[0]?.sorted_orders ?? 0

          const bucketPayload = {
            bucket_id: this.bucket,
            sorting_id_string: this.sortingIdString,
          }
          const bucketRes = (await sortingRepository.getReportOverallBuckets(bucketPayload)).data
          this.showSuccessMessage(bucketRes.message)
          this.buckets = (bucketRes.data?.child_buckets ?? []).map(bucket => ({
            id: bucket.bucket_id,
            name: bucket.bucket_name,
            key: bucket.bucket_key,
            count: bucket.count,
          }))
          this.hideWidgets = false
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async handleDispatch() {
      const result = await this.$swal({
        icon: 'question',
        title: 'Are You Sure ?',
        text: 'You want to dispatch this bucket ?',
        showCancelButton: true,
        confirmButtonText: 'Yes, Dispatch',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      })
      if (result.isConfirmed) {
        await this.dispatchBucket(this.bucket)
      }
    },
    async dispatchBucket(bucketNodeId) {
      try {
        const response = await sortingRepository.logoutBucket({
          bucket_node_id: bucketNodeId,
        })
        this.showSuccessMessage('Closed bucket successfully!')
        // Reset component state and reload
        this.loggedIn = false
        this.loading = true
        await this.checkExistingLogin()
        return response.data
      } catch (error) {
        this.showErrorMessage('Failed to login to bucket.')
        throw error
      }
    },
    async getSortingIdString() {
      if (this.bucket && this.sortingDate) {
        const selectedBucketObj = this.availableBuckets.find(
          bucket => bucket.value === this.bucket,
        )
        const bucketName = selectedBucketObj ? selectedBucketObj.name.replace(/\s+/g, '-') : ''
        this.sortingIdString = `${this.sortingDate}-Night-Ops-${bucketName}`
      } else {
        this.sortingIdString = ''
      }
    },
  },
}
</script>
<style scoped>
.close-bucket {
  background-color: #fff !important;
  border: #fff !important;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  color: rgb(186, 0, 0) !important;
  font-weight: 500 !important;
}
.dispatch-button {
  background-color: #fff !important;
  border: #fff !important;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  color: rgb(28, 0, 152) !important;
  font-weight: 500 !important;
}
</style>
